import * as Cookie from 'js-cookie';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs';

import { Action } from '../actions';
import {
    deleteCookie,
    DummyAction,
    dummyAction,
    reloadLocation,
    setCookie
} from '../actions/common';
import {
    DO_FAKE_AUTH,
    DoFakeAuth,
    FETCH_CLIENT_DEV_INFO,
    SWITCH_DUMP_VARS_STATE,
    SWITCH_SHOW_CAPTCH_STATE,
    updateClientDevInfo,
    UpdateClientDevInfoAction
} from '../actions/development-tools';
import { EpicDeps } from '../service/StoreFactory';
import {
    ClientDevData,
    DevelopmentCookieState,
    DevelopmentToolsActionType
} from '../typings/dev';
import { State } from '../typings/state';

const doFakeAuthEpic: Epic<Action, Action, State, EpicDeps> = action$ => {
    return action$.ofType(DO_FAKE_AUTH).mergeMap(
        (action: DoFakeAuth): Observable<Action> => {
            let doFakeAuthAction$;

            if (action.login) {
                doFakeAuthAction$ = Observable.of(
                    setCookie(DevelopmentToolsActionType.fakeAuth, action.login)
                );
            } else {
                doFakeAuthAction$ = Observable.of(
                    deleteCookie(DevelopmentToolsActionType.fakeAuth)
                );
            }

            return Observable.concat(
                doFakeAuthAction$,
                Observable.of(reloadLocation())
            );
        }
    );
};

const switchShowCaptchaStateEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = action$ => {
    return action$.ofType(SWITCH_SHOW_CAPTCH_STATE).mergeMap(
        (): Observable<Action> => {
            const currentState = Cookie.get(
                DevelopmentToolsActionType.showCaptcha
            );

            let switchShowCapatchaAction$;
            if (currentState === DevelopmentCookieState.ACTIVE) {
                switchShowCapatchaAction$ = Observable.of(
                    deleteCookie(DevelopmentToolsActionType.showCaptcha)
                );
            } else {
                switchShowCapatchaAction$ = Observable.of(
                    setCookie(
                        DevelopmentToolsActionType.showCaptcha,
                        DevelopmentCookieState.ACTIVE
                    )
                );
            }

            return Observable.concat(
                switchShowCapatchaAction$,
                Observable.of(reloadLocation())
            );
        }
    );
};

const switchDumpVarsStateEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = action$ => {
    return action$.ofType(SWITCH_DUMP_VARS_STATE).mergeMap(
        (): Observable<Action> => {
            const currentState = Cookie.get(
                DevelopmentToolsActionType.dumpVars
            );

            let dumpVarsAction$;
            if (currentState === DevelopmentCookieState.ACTIVE) {
                dumpVarsAction$ = Observable.of(
                    deleteCookie(DevelopmentToolsActionType.dumpVars)
                );
            } else {
                dumpVarsAction$ = Observable.of(
                    setCookie(
                        DevelopmentToolsActionType.dumpVars,
                        DevelopmentCookieState.ACTIVE
                    )
                );
            }

            return Observable.concat(
                dumpVarsAction$,
                Observable.of(reloadLocation())
            );
        }
    );
};

const fetchClientDev: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.ofType(FETCH_CLIENT_DEV_INFO).mergeMap(
        (): Observable<UpdateClientDevInfoAction | DummyAction> => {
            return Observable.fromPromise(
                deps.clientDevProvider.fetchClientDev()
            )
                .map((response: ClientDevData) => {
                    return updateClientDevInfo(response);
                })
                .catch(() => {
                    return Observable.of(dummyAction);
                });
        }
    );
};

export {
    doFakeAuthEpic,
    switchDumpVarsStateEpic,
    switchShowCaptchaStateEpic,
    fetchClientDev
};
